import {Card} from '@mui/material';
import styled from 'styled-components';

const CustomCard = styled(Card)<{height?: string}>`
	width: 800px;
	max-width: 800px;
	padding: 48px 24px 24px 24px;

	${({theme}) => theme.breakpoints.down('md')} {
		margin-top: -32px;
		border-radius: 0;
		height: ${({height}) => height || 'calc(100vh - 56px)'};
		width: 100%;
		max-width: 100%;
	}
`;

export {CustomCard};
